module.exports = __webpack_public_path__ + "static/media/case2B.7d60504.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case2B.mp4
// module id = /33+
// module chunks = 0